import { makeAutoObservable } from 'mobx'
import { CompanyRequest } from '../requests/CompanyRequest'

class CompanyStore {
  /** Company list */
  companyList = []
  companyDetail = {}
  constructor() {
    makeAutoObservable(this)
  }
  getCompanyList = params => {
    return new Promise((resolve, reject) => {
      CompanyRequest.getCompanyList(params)
        .then(response => {
          this.companyList = response.data
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }
  // Use for liên thông văn bản nội bộ
  getCompanyListV2 = () => {
    return new Promise((resolve, reject) => {
      CompanyRequest.getCompanyList()
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }

  getCompanyDetail = code => {
    return new Promise((resolve, reject) => {
      CompanyRequest.getCompanyDetail(code)
        .then(response => {
          this.companyDetail = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  createCompany = payload => {
    return new Promise((resolve, reject) => {
      CompanyRequest.createCompany(payload)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }

  updateCompany = (code, payload) => {
    return new Promise((resolve, reject) => {
      CompanyRequest.updateCompany(code, payload)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }

  updateCompanyStatus = (code, payload) => {
    return new Promise((resolve, reject) => {
      CompanyRequest.updateCompanyStatus(code, payload)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }

  deleteCompany = code => {
    return CompanyRequest.deleteCompany(code)
  }

  /** User list of company */
  // TODO: Chờ Luyện update API.
  leaderList = []
  adminList = []
  clericalList = []
  userList = []
  allUserList = []
  getUserListWithRole = (role_name, company_code) => {
    return new Promise((resolve, reject) => {
      CompanyRequest.getUserListWithRole(role_name, company_code)
        .then(response => {
          switch (role_name) {
            case 'ADMIN':
              this.adminList = response.data
              break
            case 'USER':
              this.userList = response.data
              break
            case 'CLERICAL':
              this.clericalList = response.data
              break
            case 'LEADER':
              this.leaderList = response.data
              break
            case '':
              this.allUserList = response.data
              break
            default:
              break
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /** Clear store */
  clearStore = () => {
    this.companyList.length = 0
  }
  clearAllUserList = () => {
    this.allUserList.length = 0
  }
}

const companyStore = new CompanyStore()
export default companyStore
